<div class="credit-card" [class]="statusClass">
  <div class="card-header">
    <div class="header-info">
      <i class="pi pi-building"></i>
      <h3>Información del Otorgante</h3>
    </div>
    <div class="completion-indicator">
      <span class="percentage">{{ completionPercentage }}%</span>
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="completionPercentage"></div>
      </div>
    </div>
  </div>

  <div class="card-content">
    <div *ngIf="!hasData" class="no-data">
      <i class="pi pi-info-circle"></i>
      <p>No hay información del otorgante disponible</p>
    </div>

    <div *ngIf="hasData" class="data-grid">
      <div class="data-item" *ngIf="headerData?.grantorKey">
        <label>Clave del Otorgante:</label>
        <span class="value">{{ headerData?.grantorKey }}</span>
      </div>

      <div class="data-item" *ngIf="headerData?.grantorName">
        <label>Nombre del Otorgante:</label>
        <span class="value">{{ headerData?.grantorName }}</span>
      </div>

      <div class="data-item" *ngIf="entityType === 'Moral' && headerData?.previousGrantor">
        <label>Otorgante Anterior:</label>
        <span class="value">{{ headerData?.previousGrantor }}</span>
      </div>

      <div class="data-item" *ngIf="headerData?.mediaIdentifier">
        <label>{{ entityType === 'Física' ? 'Identificador de Medio' : 'Institución' }}:</label>
        <span class="value">{{ headerData?.mediaIdentifier }}</span>
      </div>

      <div class="data-item" *ngIf="headerData?.extractionDate">
        <label>{{ entityType === 'Física' ? 'Fecha de Extracción' : 'Fecha de Generación' }}:</label>
        <span class="value">{{ formatDate(headerData?.extractionDate) }}</span>
      </div>

      <div class="data-item" *ngIf="entityType === 'Moral' && headerData?.reportingPeriod">
        <label>Periodo que Reporta:</label>
        <span class="value">{{ headerData?.reportingPeriod }}</span>
      </div>

      <div class="data-item" *ngIf="headerData?.grantorNote">
        <label>{{ entityType === 'Física' ? 'Nota del Otorgante' : 'Formato' }}:</label>
        <span class="value">{{ headerData?.grantorNote }}</span>
      </div>

      <div class="data-item" *ngIf="headerData?.version">
        <label>Versión:</label>
        <span class="value">{{ headerData?.version }}</span>
      </div>

      <!-- Campos vacíos mostrados como placeholders -->
      <div class="data-item empty" *ngIf="!headerData?.grantorKey">
        <label>Clave del Otorgante:</label>
        <span class="placeholder">No especificado</span>
      </div>

      <div class="data-item empty" *ngIf="!headerData?.grantorName">
        <label>Nombre del Otorgante:</label>
        <span class="placeholder">No especificado</span>
      </div>
    </div>
  </div>
</div>
